import { render } from "./ActivitiesListingRelatedItem.vue?vue&type=template&id=03133ffe&scoped=true"
import script from "./ActivitiesListingRelatedItem.vue?vue&type=script&lang=js"
export * from "./ActivitiesListingRelatedItem.vue?vue&type=script&lang=js"

import "./ActivitiesListingRelatedItem.vue?vue&type=style&index=0&id=03133ffe&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03133ffe"]])

export default __exports__